import axios from './axios';

export const fetchCurrentTournament = async () => {
    const response = await axios.get('/tournament/current');
    return response.data;
};

export const fetchTournamentLeaderboard = async () => {
    const response = await axios.get('/tournament/leaderboard');
    return response.data;
};

export const fetchTournamentEntry = async () => {
    const response = await axios.get('/tournament/entry');
    return response.data;
};

export const fetchTournamentHistory = async () => {
    const response = await axios.get('/tournament/history');
    return response.data;
};

export const fetchLeagueHistory = async (league) => {
    const response = await axios.get(`/tournament/league-history/${encodeURIComponent(league)}`);
    return response.data;
};

export const fetchTournamentGames = async (league) => {
    const url = league != null ? `/tournament/games?league=${encodeURIComponent(league)}` : '/tournament/games';
    const response = await axios.get(url);
    return response.data;
};

export const playTournamentGame = async (opponentEntryID, substitutions) => {
    const response = await axios.post('/tournament/play', { opponentEntryID, substitutions });
    return response.data;
};

export const fetchTournamentResults = async (tournamentID) => {
    const response = await axios.get(`/tournament/${tournamentID}/results`);
    return response.data;
};

export const fetchTrophies = async () => {
    const response = await axios.get('/tournament/trophies');
    return response.data;
};

export const fetchActiveLeagues = async () => {
    const response = await axios.get('/tournament/leagues');
    return response.data;
};

export const fetchLeagueTournament = async (league) => {
    const response = await axios.get(`/tournament/league/${league}`);
    return response.data;
};

export const finalizeTournament = async ({ force = false } = {}) => {
    const response = await axios.post(`/tournament/finalize${force ? '?force=true' : ''}`);
    return response.data;
};

export const updateTournamentRoster = async (swaps) => {
    const response = await axios.put('/tournament/roster', { swaps });
    return response.data;
};

export const changeTournamentTeam = async (userTeamID) => {
    const response = await axios.put('/tournament/change-team', { userTeamID });
    return response.data;
};

export const fetchTournamentPointsMonthly = async (monthYear) => {
    const response = await axios.get(`/tournament/points/leaderboard/monthly/${encodeURIComponent(monthYear)}`);
    return response.data;
};

export const fetchTournamentPointsAllTime = async () => {
    const response = await axios.get('/tournament/points/leaderboard/alltime');
    return response.data;
};
